import { db } from '../db/database';

export async function ensureLocalCatalog(): Promise<boolean> {
  // Never wait for a network request before showing the last verified local catalog.
  const [services, addons] = await Promise.all([
    db.services.filter((service) => service.active !== false).count(),
    db.addons.filter((addon) => addon.active !== false).count(),
  ]);
  return services > 0 && addons > 0;
}
